var layout;

layout = function() {
  var $, icon, module, moduleName, neededModule, winWidth;
  moduleName = 'layout';
  module = document.querySelector("." + moduleName);
  icon = document.querySelectorAll("." + moduleName + "__j-close");
  $ = require('jquery');
  neededModule = $("." + moduleName + "__j-close").parents("." + moduleName);
  winWidth = $(window).width();
  if (winWidth > 1023) {
    return Array.prototype.forEach.call(icon, function(el, i) {
      var iconOffTop, iconOffsets;
      iconOffsets = el.getBoundingClientRect();
      iconOffTop = iconOffsets.top;
      return neededModule.each(function() {
        return this.addEventListener('scroll', function() {
          var offTopToIcon;
          if ($(window).width() > 479) {
            offTopToIcon = $(this).scrollTop() + 35;
          } else {
            offTopToIcon = $(this).scrollTop() + 15;
          }
          return el.style.top = offTopToIcon + "px";
        });
      });
    });
  }
};

module.exports = layout;
